var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"mx-7 white--text text-uppercase text-decoration-none",attrs:{"to":_vm.link},on:{"click":function($event){$event.preventDefault();return _vm.handleLink.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.proposal.descr)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }